import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import requester from '../../lib/requester';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import moment from 'moment';
import _ from 'lodash';
import ReactExport from 'react-export-excel';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import Autocomplete from '../../component/autocomplete';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
	constructor(props) {
		super(props);
		this.state = {
			startDate: new Date(),
			endDate: new Date(),
			dataTable: [],
			baseTable: [],
			search: '',
			user: JSON.parse(window.localStorage.getItem('is_user')),
			fromDate: '',
			toDate: '',
			setStatus: '',
			submittedDateFrom: '',
			submittedDateTo: '',
			status: '',
			activeStatus: '',
			setBranch: '',
			setPrincipal: '',
			lovPrincipal: [],
			princid: '',
			lovBranch: [],
			export: false,
			originOrgid: '',
			customerId: 0,
			customerName: '',
			bupotexist: '',
			expDate: '',
			awbcabang: '',
			awbho: '',
		};
	}

	componentDidMount = () => {
		// let url = '/api/traces/v1/report/reportho'
		// let param = {
		//     org_id: this.state.user.org_id,
		//     source: 'arman'
		// }
		// this.setState({ loading: true })
		// requester.postTraces(url, param, {
		//     success: function (response) {
		//         let { data } = response.data
		//         data.data.map((item, index) => {
		//             item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
		//             item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
		//             return item
		//         })
		//         this.setState({ loading: false, dataTable: data.data, baseTable: data.data })
		//     }.bind(this),
		//     error: function (e) {
		//         this.setState({ loading: false })
		//     }.bind(this)
		// })
		this.getPrincipal();
		this.getBranch();
	};

	onSelectCustomer = (suggestions, index) => {
		let customer_id = 0;
		let customer_name = '';
		this.setState({ customerId: 0, customerName: '' });
		customer_id = suggestions.value ? suggestions.value : 0;
		customer_name = suggestions.text ? suggestions.text : null;
		this.setState({ customerId: customer_id, customerName: customer_name });
		// console.log(customerSave)
	};

	onChangeAutocompleteCust = (q) => {
		this.setState({ customerId: 0, customerName: '' });
		let param = {
			// branch_id: this.state.user.org_id,
			branch_id: this.state.setBranch,
			customer_name: q,
		};
		let container = [];
		this.setState({ customerId: 0, customerName: '' });
		return new Promise((resolve) => {
			requester.postOracle('/api/orafin/v1/participant/customer', param, {
				success: function (response) {
					var api_response = response.data.data;
					container = api_response.map((item, index) => {
						item.text = item.CUSTOMER_NAME;
						item.value = item.CUSTOMER_ID;
						return item;
					});
					resolve(container);
				},
				error: function (e) {
					resolve([]);
				},
			});
		});
	};

	getBranch = () => {
		// let branchGroup = this.state.user.branch.map((item, index) => {
		//     return item.org_id
		// })

		let url = '/api/traces/v1/general/list-cabang';
		requester.getTraces(url, {
			success: function (response) {
				this.setState({ lovBranch: response.data.data });
			}.bind(this),
			error: function (e) {
				console.log(e);
			},
		});

		if (this.state.user.origin === 'CAB') {
			this.state.originOrgid = this.state.user.org_id;
			this.state.setBranch = this.state.user.org_id;
		}

		// this.setState({ lovBranch: this.state.user.branch });
		console.log(this.state.originOrgid);
	};

	renderTable = () => {
		const data = {
			columns: [
				{
					Header: 'BRANCH',
					accessor: 'BRANCH',
					filterable: true,
					width: 200,
				},
				{
					Header: 'SUBMIT_DATE_CLAIM',
					accessor: 'SUBMIT_DATE_CLAIM',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},
				{
					Header: 'AWB_NO_CABANG',
					accessor: 'AWB_NO_CABANG',
					filterable: true,
					width: 200,
				},
				{
					Header: 'AWB_NO_CABANG_SUBMIT_DATE',
					accessor: 'AWB_NO_CABANG_SUBMIT_DATE',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},
				{
					Header: 'AWB_RECEIPT_DATE_HO',
					accessor: 'AWB_RECEIPT_DATE_HO',
					filterable: true,
					width: 200,

					// ,filterable: true
					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
				},
				{
					Header: 'PRINCIPAL_CODE',
					accessor: 'PRINCIPAL_CODE',
					filterable: true,
					width: 200,
				},
				{
					Header: 'AWB_NO_HO',
					accessor: 'AWB_NO_HO',
					filterable: true,
					width: 200,
				},
				{
					Header: 'AWB HO Submit to Principal',
					accessor: 'AWB_HO_SUBMIT_TO_PRINCIPAL',
					filterable: true,
					width: 200,
					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
				},
				{
					Header: 'AWB_RECEIPT_DATE_PRINCIPAL',
					accessor: 'AWB_RECEIPT_DATE_PRINCIPAL',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},
				{
					Header: 'PRINCIPAL_CLAIM_RECEIPT_DATE',
					accessor: 'PRINCIPAL_CLAIM_RECEIPT_DATE',
					filterable: true,
					width: 200,
					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},
				{
					Header: 'KWITANSI',
					accessor: 'KWITANSI',
					filterable: true,
					width: 200,
				},
				{
					Header: 'CLAIM_NUMBER',
					accessor: 'CLAIM_NUMBER',
					filterable: true,
					width: 200,
				},
				{
					Header: 'STATUS',
					accessor: 'STATUS',
					filterable: true,
					width: 200,
				},
				{
					Header: 'APPROVED_REJECTED_DATE',
					accessor: 'APPROVED_REJECTED_DATE',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},
				{
					Header: 'REASON_REJECTED',
					accessor: 'REASON_REJECTED',
					filterable: true,
					width: 200,
				},
				{
					Header: 'CUSTOMER_NAME',
					accessor: 'CUSTOMER_NAME',
					filterable: true,
					width: 200,
				},
				{
					Header: 'PROGRAM_TYPE',
					accessor: 'PROGRAM_TYPE',
					filterable: true,
					width: 200,
				},
				{
					Header: 'PROGRAM_NUMBER',
					accessor: 'PROGRAM_NUMBER',
					filterable: true,
					width: 200,
				},
				{
					Header: 'PROGRAM_DESCRIPTIONS',
					accessor: 'PROGRAM_DESCRIPTIONS',
					filterable: true,
					width: 200,
				},
				{
					Header: 'REF_NUMBER/SKP',
					accessor: 'REF_NUMBER',
					filterable: true,
					width: 200,
				},
				{
					Header: 'TRACES_NUMBER',
					accessor: 'TRACES_NUMBER',
					filterable: true,
					width: 200,
				},
				{
					Header: 'START_DATE_PROGRAM',
					accessor: 'START_DATE_PROGRAM',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},
				{
					Header: 'END_DATE_PROGRAM',
					accessor: 'END_DATE_PROGRAM',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},
				{
					Header: 'CLAIM_EXP_DATE',
					accessor: 'CLAIM_EXP_DATE',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},

				{
					Header: 'NILAI_DPP',
					accessor: 'NILAI_DPP',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'NILAI_PPN',
					accessor: 'NILAI_PPN',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'TOTAL_CLAIM',
					accessor: 'TOTAL_CLAIM',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},

				{
					Header: 'PPH_TYPE',
					accessor: 'PPH_TYPE',
					filterable: true,
					width: 200,
				},
				{
					Header: 'PPH_RATE',
					accessor: 'PPH_RATE',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'NILAI_PPH',
					accessor: 'NILAI_PPH',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'CLAIM_NET',
					accessor: 'CLAIM_NET',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},

				{
					Header: 'NO_NPWP_RELASI',
					accessor: 'NO_NPWP_RELASI',
					filterable: true,
					width: 200,
				},
				{
					Header: 'NAMA_NPWP_RELASI',
					accessor: 'NAMA_NPWP_RELASI',
					filterable: true,
					width: 200,
				},
				{
					Header: 'ALAMAT_NPWP_RELASI',
					accessor: 'ALAMAT_NPWP_RELASI',
					filterable: true,
					width: 200,
				},
				{
					Header: 'TAX_NO',
					accessor: 'TAX_NO',
					filterable: true,
					width: 200,
				},
				{
					Header: 'TAX_DATE',
					accessor: 'TAX_DATE',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},
				{
					Header: 'SKB_NUMBER',
					accessor: 'SKB_NUMBER',
					filterable: true,
					width: 200,
				},
				{
					Header: 'COVER_LETTER_NUMBER',
					accessor: 'COVER_LETTER_NUMBER',
					filterable: true,
					width: 200,
				},
				{
					Header: 'COVER_LETTER_DATE',
					accessor: 'COVER_LETTER_DATE',
					filterable: true,
					width: 200,
					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					filterable: true,
				},
				{
					Header: 'PAYMENT_AMOUNT',
					accessor: 'PAYMENT_AMOUNT',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'PAYMENT_DATE',
					accessor: 'PAYMENT_DATE',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},
				{
					Header: 'NO_EBUKPOT',
					accessor: 'NO_EBUKPOT',
					filterable: true,
					width: 200,
				},
				{
					Header: 'UPLOAD_DATE_EBUKPOT',
					accessor: 'UPLOAD_DATE_EBUKPOT',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},
				{
					Header: 'NILAI_EBUKPOT',
					accessor: 'NILAI_EBUKPOT',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'TGL_FISIK_BUKPOT',
					accessor: 'TGL_FISIK_BUKPOT',
					filterable: true,
					width: 200,

					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
					// ,filterable: true
				},

				// {
				//   Header: "PRINCIPAL_CLAIM_ID",
				//   accessor: "PRINCIPAL_CLAIM_ID",
				//   filterable: true, width: 200,
				// },

				// {
				//   Header: "NOTES PARTICIPANTS",
				//   accessor: "NOTES",
				//   filterable: true, width: 200,
				// },
				{
					Header: 'E-Bupot Upload By',
					accessor: 'EBUPOT_UPLOAD_BY',
					filterable: true,
					width: 200,
				},
				{
					Header: 'E-Bupot Upload Date',
					accessor: 'EBUPOT_UPLOAD_DATE',
					filterable: true,
					width: 200,
					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
				},
				//==============================================================
				//==============================================================
			],
			rows: this.state.dataTable,
		};
		return (
			<ReactTable
				className='fullWidth'
				data={data.rows}
				columns={data.columns}
				defaultPageSize={10}
				defaultFilterMethod={(filter, row, column) => {
					let columnes = row[filter.id];
					return columnes
						? columnes.toLowerCase().includes(filter.value.toLowerCase())
						: '';
				}}
			/>
		);
	};

	exportToExcel = () => {
		const data = this.state.dataTable;
		let filename = 'traces-ho-' + moment(new Date()).format('DDMMYYYYHHmmss');
		const exportData = data.map((el, idx) => {
			const {
				BRANCH,
				SUBMIT_DATE_CLAIM,
				AWB_NO_CABANG,
				AWB_NO_CABANG_SUBMIT_DATE,
				AWB_RECEIPT_DATE_HO,
				PRINCIPAL_CODE,
				AWB_NO_HO,
				LT_CAB_HO,
				AWB_RECEIPT_DATE_PRINCIPAL,
				PRINCIPAL_CLAIM_RECEIPT_DATE,
				LT_HO_PRINCIPAL,
				PAYMENT_METHOD,
				KWITANSI,
				CLAIM_NUMBER,
				STATUS,
				APPROVED_REJECTED_DATE,
				REASON_REJECTED,
				LT_APPROVAL_PRINCIPAL,
				CUST_INVOICE_NO,
				PRINCIPAL_CLAIM_ID,
				PRINCIPAL_STATUS,
				CUSTOMER_GROUP,
				CUSTOMER_NAME,
				PROGRAM_TYPE,
				PROGRAM_DESCRIPTIONS,
				REF_NUMBER,
				TRACES_NUMBER,
				START_DATE_PROGRAM,
				END_DATE_PROGRAM,
				CLAIM_EXP_DATE,
				NILAI_DPP,
				NILAI_PPN,
				TOTAL_CLAIM,
				PPH_TYPE,
				PPH_RATE,
				NILAI_PPH,
				CLAIM_NET,
				NO_NPWP_RELASI,
				NAMA_NPWP_RELASI,
				ALAMAT_NPWP_RELASI,
				TAX_NO,
				TAX_DATE,
				SKB_NUMBER,
				SUPPLIER_NAME,
				SUPPLIER_SITE,
				AP_INVOICE_NUM,
				COVER_LETTER_NUMBER,
				COVER_LETTER_DATE,
				RECEIPT_NO_CABANG,
				RECEIPT_DATE,
				RECEIPT_AMOUNT,
				ACCOUNT_NO,
				ACCOUNT_NAME,
				BANK_ACCOUNT,
				PAYMENT_AMOUNT,
				PAYMENT_DATE,
				NO_EBUKPOT,
				UPLOAD_DATE_EBUKPOT,
				NILAI_EBUKPOT,
				TGL_FISIK_BUKPOT,
				NOTES,
			} = el;
			return {
				BRANCH,
				SUBMIT_DATE_CLAIM: SUBMIT_DATE_CLAIM
					? moment(SUBMIT_DATE_CLAIM).format('DD MMM YYYY')
					: '',
				AWB_NO_CABANG,
				AWB_NO_CABANG_SUBMIT_DATE: AWB_NO_CABANG_SUBMIT_DATE
					? moment(AWB_NO_CABANG_SUBMIT_DATE).format('DD MMM YYYY')
					: '',
				AWB_RECEIPT_DATE_HO: AWB_RECEIPT_DATE_HO
					? moment(AWB_RECEIPT_DATE_HO).format('DD MMM YYYY')
					: '',
				PRINCIPAL_CODE,
				AWB_NO_HO,
				LT_CAB_HO,
				AWB_RECEIPT_DATE_PRINCIPAL: AWB_RECEIPT_DATE_PRINCIPAL
					? moment(AWB_RECEIPT_DATE_PRINCIPAL).format('DD MMM YYYY')
					: '',
				PRINCIPAL_CLAIM_RECEIPT_DATE: PRINCIPAL_CLAIM_RECEIPT_DATE
					? moment(PRINCIPAL_CLAIM_RECEIPT_DATE).format('DD MMM YYYY')
					: '',
				LT_HO_PRINCIPAL,
				PAYMENT_METHOD,
				KWITANSI,
				CLAIM_NUMBER,
				STATUS,
				APPROVED_REJECTED_DATE: APPROVED_REJECTED_DATE
					? moment(APPROVED_REJECTED_DATE).format('DD MMM YYYY')
					: '',
				REASON_REJECTED,
				LT_APPROVAL_PRINCIPAL,
				CUST_INVOICE_NO,
				PRINCIPAL_CLAIM_ID,
				PRINCIPAL_STATUS,
				CUSTOMER_GROUP,
				CUSTOMER_NAME,
				PROGRAM_TYPE,
				PROGRAM_DESCRIPTIONS,
				REF_NUMBER_SKP : REF_NUMBER,
				TRACES_NUMBER,
				START_DATE_PROGRAM: START_DATE_PROGRAM
					? moment(START_DATE_PROGRAM).format('DD MMM YYYY')
					: '',
				END_DATE_PROGRAM: END_DATE_PROGRAM
					? moment(END_DATE_PROGRAM).format('DD MMM YYYY')
					: '',
				CLAIM_EXP_DATE: CLAIM_EXP_DATE
					? moment(CLAIM_EXP_DATE).format('DD MMM YYYY')
					: '',
				NILAI_DPP,
				NILAI_PPN,
				TOTAL_CLAIM,
				PPH_TYPE,
				PPH_RATE,
				NILAI_PPH,
				CLAIM_NET,
				NO_NPWP_RELASI,
				NAMA_NPWP_RELASI,
				ALAMAT_NPWP_RELASI,
				TAX_NO,
				TAX_DATE: TAX_DATE ? moment(TAX_DATE).format('DD MMM YYYY') : '',
				SKB_NUMBER,
				SUPPLIER_NAME,
				SUPPLIER_SITE,
				AP_INVOICE_NUM,
				COVER_LETTER_NUMBER,
				COVER_LETTER_DATE: COVER_LETTER_DATE
					? moment(COVER_LETTER_DATE).format('DD MMM YYYY')
					: '',
				RECEIPT_NO_CABANG,
				RECEIPT_DATE,
				RECEIPT_AMOUNT,
				ACCOUNT_NO,
				ACCOUNT_NAME,
				BANK_ACCOUNT,
				PAYMENT_AMOUNT,
				PAYMENT_DATE: PAYMENT_DATE
					? moment(PAYMENT_DATE).format('DD MMM YYYY')
					: '',
				NO_EBUKPOT,
				UPLOAD_DATE_EBUKPOT,
				NILAI_EBUKPOT,
				TGL_FISIK_BUKPOT,
				PRINCIPAL_NOTES : NOTES,
			};
		});

		// console.log(exportData);
		return requester.exportToXlsx(exportData, filename);

		// return (
		//   <ExcelFile
		//     filename={filename}
		//     fileExtension="xlsx"
		//     element={
		//       <button className="btn btn-success btn-block">
		//         <i className="fas fa-file-excel" />
		//         Export to Excel
		//       </button>
		//     }
		//   >
		//     <ExcelSheet data={dataSet2} name="Leaves">
		//       <ExcelColumn label="BRANCH" value="BRANCH" />
		//       <ExcelColumn label="SUBMIT_DATE_CLAIM" value="SUBMIT_DATE_CLAIM" />
		//       <ExcelColumn label="AWB_NO_CABANG" value="AWB_NO_CABANG" />
		//       <ExcelColumn
		//         label="AWB_NO_CABANG_SUBMIT_DATE"
		//         value="AWB_NO_CABANG_SUBMIT_DATE"
		//       />
		//       <ExcelColumn
		//         label="AWB_RECEIPT_DATE_HO"
		//         value="AWB_RECEIPT_DATE_HO"
		//       />
		//       <ExcelColumn label="PRINCIPAL_CODE" value="PRINCIPAL_CODE" />
		//       <ExcelColumn label="AWB_NO_HO" value="AWB_NO_HO" />
		//       <ExcelColumn label="LT_CAB_HO" value="LT_CAB_HO" />
		//       <ExcelColumn
		//         label="AWB_RECEIPT_DATE_PRINCIPAL"
		//         value="AWB_RECEIPT_DATE_PRINCIPAL"
		//       />
		//       <ExcelColumn
		//         label="PRINCIPAL_CLAIM_RECEIPT_DATE"
		//         value="PRINCIPAL_CLAIM_RECEIPT_DATE"
		//       />
		//       <ExcelColumn label="LT_HO_PRINCIPAL" value="LT_HO_PRINCIPAL" />
		//       <ExcelColumn label="PAYMENT_METHOD" value="PAYMENT_METHOD" />
		//       <ExcelColumn label="KWITANSI" value="KWITANSI" />
		//       <ExcelColumn label="CLAIM_NUMBER" value="CLAIM_NUMBER" />
		//       <ExcelColumn label="STATUS" value="STATUS" />
		//       <ExcelColumn
		//         label="APPROVED_REJECTED_DATE"
		//         value="APPROVED_REJECTED_DATE"
		//       />
		//       <ExcelColumn label="REASON_REJECTED" value="REASON_REJECTED" />
		//       <ExcelColumn
		//         label="LT_APPROVAL_PRINCIPAL"
		//         value="LT_APPROVAL_PRINCIPAL"
		//       />
		//       <ExcelColumn label="CUST_INVOICE_NO" value="CUST_INVOICE_NO" />
		//       <ExcelColumn label="PRINCIPAL_CLAIM_ID" value="PRINCIPAL_CLAIM_ID" />
		//       <ExcelColumn label="PRINCIPAL_STATUS" value="PRINCIPAL_STATUS" />
		//       <ExcelColumn label="CUSTOMER_GROUP" value="CUSTOMER_GROUP" />
		//       <ExcelColumn label="CUSTOMER_NAME" value="CUSTOMER_NAME" />
		//       <ExcelColumn label="PROGRAM_TYPE" value="PROGRAM_TYPE" />
		//       <ExcelColumn
		//         label="PROGRAM_DESCRIPTIONS"
		//         value="PROGRAM_DESCRIPTIONS"
		//       />
		//       <ExcelColumn label="REF_NUMBER/SKP" value="REF_NUMBER" />
		//       <ExcelColumn label="TRACES_NUMBER" value="TRACES_NUMBER" />
		//       <ExcelColumn label="START_DATE_PROGRAM" value="START_DATE_PROGRAM" />
		//       <ExcelColumn label="END_DATE_PROGRAM" value="END_DATE_PROGRAM" />
		//       <ExcelColumn label="CLAIM_EXP_DATE" value="CLAIM_EXP_DATE" />
		//       <ExcelColumn label="NILAI_DPP" value="NILAI_DPP" />
		//       <ExcelColumn label="NILAI_PPN" value="NILAI_PPN" />
		//       <ExcelColumn label="TOTAL_CLAIM" value="TOTAL_CLAIM" />
		//       <ExcelColumn label="PPH_TYPE" value="PPH_TYPE" />
		//       <ExcelColumn label="PPH_RATE" value="PPH_RATE" />
		//       <ExcelColumn label="NILAI_PPH" value="NILAI_PPH" />
		//       <ExcelColumn label="CLAIM_NET" value="CLAIM_NET" />
		//       <ExcelColumn label="NO_NPWP_RELASI" value="NO_NPWP_RELASI" />
		//       <ExcelColumn label="NAMA_NPWP_RELASI" value="NAMA_NPWP_RELASI" />
		//       <ExcelColumn label="ALAMAT_NPWP_RELASI" value="ALAMAT_NPWP_RELASI" />
		//       <ExcelColumn label="TAX_NO" value="TAX_NO" />
		//       <ExcelColumn label="TAX_DATE" value="TAX_DATE" />
		//       <ExcelColumn label="SKB_NUMBER" value="SKB_NUMBER" />
		//       <ExcelColumn label="SUPPLIER_NAME" value="SUPPLIER_NAME" />
		//       <ExcelColumn label="SUPPLIER_SITE" value="SUPPLIER_SITE" />
		//       <ExcelColumn label="AP_INVOICE_NUM" value="AP_INVOICE_NUM" />
		//       <ExcelColumn
		//         label="COVER_LETTER_NUMBER"
		//         value="COVER_LETTER_NUMBER"
		//       />
		//       <ExcelColumn label="COVER_LETTER_DATE" value="COVER_LETTER_DATE" />
		//       <ExcelColumn label="RECEIPT_NO_CABANG" value="RECEIPT_NO_CABANG" />
		//       <ExcelColumn label="RECEIPT_DATE" value="RECEIPT_DATE" />
		//       <ExcelColumn label="RECEIPT_AMOUNT" value="RECEIPT_AMOUNT" />
		//       <ExcelColumn label="ACCOUNT_NO" value="ACCOUNT_NO" />
		//       <ExcelColumn label="ACCOUNT_NAME" value="ACCOUNT_NAME" />
		//       <ExcelColumn label="BANK_ACCOUNT" value="BANK_ACCOUNT" />
		//       <ExcelColumn label="PAYMENT_AMOUNT" value="PAID_AMOUNT" />
		//       <ExcelColumn label="PAYMENT_DATE" value="PAYMENT_DATE" />
		//       <ExcelColumn label="NO_EBUKPOT" value="NO_EBUKPOT" />
		//       <ExcelColumn
		//         label="UPLOAD_DATE_EBUKPOT"
		//         value="UPLOAD_DATE_EBUKPOT"
		//       />
		//       <ExcelColumn label="NILAI_EBUKPOT" value="NILAI_EBUKPOT" />
		//       <ExcelColumn label="TGL_FISIK_BUKPOT" value="TGL_FISIK_BUKPOT" />
		//       <ExcelColumn label="PRINCIPAL_NOTES" value="NOTES" />
		//     </ExcelSheet>
		//   </ExcelFile>
		// );
	};

	getPrincipal = () => {
		let url = '/api/traces/v1/general/list-principal';
		requester.getTraces(url, {
			success: function (response) {
				this.setState({ lovPrincipal: response.data.data });
			}.bind(this),
			error: function (e) {
				console.log(e);
			},
		});
	};

	goDetail = (rows) => {
		let { row } = rows;
		this.props.history.push('/admin/assign/summary/' + row.program_customer_id);
	};

	handleSearch = () => {
		let url = '/api/traces/v1/report/report-claim-principal';
		let param = {
			exportXLS: this.state.export,
			org_id: this.state.setBranch,
			source: 'arman',
			status: this.state.setStatus,
			active_status: this.state.activeStatus,
			principal: this.state.user.org_id,
			customerid: this.state.customerId,
			ebupot_exist: this.state.bupotexist,
			awbho: this.state.awbho,
			awbcabang: this.state.awbcabang,
			from_date:
				this.state.fromDate != ''
					? moment(new Date(this.state.fromDate)).format('YYYY-MM-DD')
					: '',
			to_date:
				this.state.toDate != ''
					? moment(new Date(this.state.toDate)).format('YYYY-MM-DD')
					: '',
			submit_from:
				this.state.submittedDateFrom != ''
					? moment(new Date(this.state.submittedDateFrom)).format('YYYY-MM-DD')
					: '',
			submit_to:
				this.state.submittedDateTo != ''
					? moment(new Date(this.state.submittedDateTo)).format('YYYY-MM-DD')
					: '',
			expdate:
				this.state.expDate != ''
					? moment(new Date(this.state.expDate)).format('YYYY-MM-DD')
					: '',
		};

		this.setState({ loading: true });
		requester.postTraces(url, param, {
			success: function (response) {
				let { data } = response.data;
				data.data.map((item, index) => {
					//   item.formatted_start_date = moment(item.start_date).format(
					//     "DD-MM-YYYY"
					//   );
					//   item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
					item.formatted_submit_date_claim = moment(
						item.submit_date_claim
					).format('DD-MMM-YYYY');

					return item;
				});

				if (this.state.export) {
					let url = data.url;
					window.open(url, '_blank');
				}
				this.setState({
					loading: false,
					dataTable: data.data,
					baseTable: data.data,
					export: false,
				});
			}.bind(this),
			error: function (e) {
				this.setState({ loading: false });
			}.bind(this),
		});
		// this.getPrincipal();
		// this.getBranch();

		console.log(this.state.dataTable);
	};

	handleChangeStatus = (e) => {
		this.state.setStatus = e.target.value;
	};

	handleChangeBupot = (e) => {
		this.state.bupotexist = e.target.value;
	};

	handleChangeBranch = (e) => {
		this.state.setBranch = e.target.value;
	};

	handleChangePrincipal = (e) => {
		this.state.setPrincipal = e.target.value;
	};

	handleChangeValue = (event) => {
		let value = event.target.value;
		let valname = event.target.name;

		// this.setState({ activeflag: value })

		if (valname === 'org_id') {
			this.setState({ princid: value });
		}

		window.setTimeout(() => {
			console.log(valname);
		}, 100);
	};

	handleFind = () => {
		// let value = e.target.value
		// let url = '/api/traces/v1/report/reportprincipal'
		// let param = {
		//     "org_id": this.state.user.org_id,
		//     "status": this.state.setStatus,
		//     "from_date": moment(this.state.fromDate).format('YYYY-MM-DD'),
		//     "to_date":moment(this.state.toDate).format('YYYY-MM-DD'),
		//     "princlov" : this.state.princid

		// }

		let url = '/api/traces/v1/report/reportho';
		let param = {
			org_id: this.state.user.org_id,
			source: 'arman',
			from_date: moment(this.state.fromDate).format('YYYY-MM-DD'),
			to_date: moment(this.state.toDate).format('YYYY-MM-DD'),
		};

		this.setState({ loading: true, search: '' });
		requester.postTraces(url, param, {
			success: function (response) {
				let { data } = response.data;
				data.map((item, index) => {
					item.formatted_start_date = moment(item.start_date).format(
						'DD-MM-YYYY'
					);
					item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY');
					return item;
				});
				this.setState({ loading: false, dataTable: data, baseTable: data });
			}.bind(this),
			error: function (e) {
				this.setState({ loading: false });
			}.bind(this),
		});
	};

	badgeClass = (status) => {
		let className = '';
		if (status === 'P') {
			className = 'badge badge-info';
		} else if (status === 'A') {
			className = 'badge badge-success';
		} else if (status === 'R') {
			className = 'badge badge-danger';
		} else if (status === 'S') {
			className = 'badge badge-secondary';
		}
		console.log(className);
		return className;
	};

	mappingStatus = (status) => {
		let mappingStatus = '';
		if (status === 'P') {
			mappingStatus = 'PROPOSE';
		} else if (status === 'A') {
			mappingStatus = 'APPROVED';
		} else if (status === 'R') {
			mappingStatus = 'REJECT';
		} else if (status === 'S') {
			mappingStatus = 'ASSIGN';
		}
		console.log(mappingStatus);
		return mappingStatus;
	};

	handlefromDate = (date) => {
		this.setState({ fromDate: date });
	};

	handletoDate = (date) => {
		this.setState({ toDate: date });
	};

	handleSubmittedDateFrom = (date) => {
		this.setState({ submittedDateFrom: date });
	};

	handleSubmittedDateTo = (date) => {
		this.setState({ submittedDateTo: date });
	};

	handleexpDate = (date) => {
		this.setState({ expDate: date });
	};

	handleExport = () => {
		this.setState({ export: true });
		let app = this;
		window.setTimeout(() => {
			app.handleSearch();
		}, 200);
	};

	handleChangeAwbCabang = (event) => {
		let value = event.target.value;
		let name = event.target.name;
		this.setState({ awbcabang: value });
	};

	handleChangeAwbHO = (event) => {
		let value = event.target.value;
		let name = event.target.name;
		this.setState({ awbho: value });
	};

	render() {
		return (
			<div>
				<section className='content'>
					<div className='container-fluid'>
						<div className='row ml-1'>
							<div className='col-lg-12'>
								<div className='card card-info'>
									<div className='card-header'>List</div>
									<div className='card-body'>
										<div className='row'>
											<div className='col-md-12'>
												<div className='card'>
													<div className='card-body'>
														<div className='row mt-3'></div>

														<div className='row'>
															<div className='col-md-2 mt-1'>
																Submitted Date From{' '}
															</div>
															<div className='col-lg-3'>
																<DatePicker
																	placeholder='Submitted Date from'
																	selected={this.state.submittedDateFrom}
																	dateFormat='d-MMM-yyyy'
																	className='form-control myDatePicker'
																	popperPlacement='bottom-end'
																	onChange={this.handleSubmittedDateFrom}
																/>
															</div>
															<div className='col-md-2 mt-1'>
																Submitted Date To{' '}
															</div>
															<div className='col-lg-3'>
																<DatePicker
																	placeholder='Submitted Date from'
																	selected={this.state.submittedDateTo}
																	dateFormat='d-MMM-yyyy'
																	className='form-control'
																	popperPlacement='bottom-end'
																	onChange={this.handleSubmittedDateTo}
																/>
															</div>
														</div>
														<div className='row mt-3'>
															<div className='col-md-2 mt-1'>
																Approved Date From{' '}
															</div>
															<div className='col-lg-3'>
																<DatePicker
																	placeholder='Submitted Date from'
																	selected={this.state.fromDate}
																	dateFormat='d-MMM-yyyy'
																	className='form-control'
																	popperPlacement='bottom-end'
																	onChange={this.handlefromDate}
																/>
															</div>
															<div className='col-md-2 mt-1'>
																Approved Date To{' '}
															</div>
															<div className='col-lg-3'>
																<DatePicker
																	placeholder='Submitted Date from'
																	selected={this.state.toDate}
																	dateFormat='d-MMM-yyyy'
																	className='form-control'
																	popperPlacement='bottom-end'
																	onChange={this.handletoDate}
																/>
															</div>
														</div>
														<div className='row mt-3'>
															<div className='col-md-2 mt-1'>
																Expired After{' '}
															</div>
															<div className='col-lg-3'>
																<DatePicker
																	placeholder='Submitted Date from'
																	selected={this.state.expDate}
																	dateFormat='d-MMM-yyyy'
																	className='form-control'
																	popperPlacement='bottom-end'
																	onChange={this.handleexpDate}
																/>
															</div>
															<div className='col-md-2'>Claim Status</div>
															<div className='col-md-3'>
																<select
																	className='form-control'
																	onChange={this.handleChangeStatus.bind(this)}
																>
																	<option value=''>All</option>
																	<option value='D'>Draft</option>
																	<option value='P'>Propose</option>
																	<option value='A'>Approve</option>
																	<option value='I'>Invalid</option>
																	<option value='E'>Revise</option>
																	<option value='R'>Reject</option>
																</select>
															</div>
														</div>

														<div className='row mt-3'>
															<div className='col-md-2'>Branch</div>
															<div className='col-md-3'>
																<select
																	className='form-control'
																	name='branchId'
																	onChange={this.handleChangeBranch.bind(this)}
																>
																	<option value=''>ALL</option>
																	{this.state.lovBranch.map((item, index) => (
																		<option
																			value={item.org_id}
																			key={index}
																			selected={
																				this.state.originOrgid == item.org_id
																					? true
																					: false
																			}
																		>
																			{item.org_name}
																		</option>
																	))}
																</select>
															</div>
														</div>
														<div className='row mt-3'>
															<div className='col-md-2'>E-Bupot</div>
															<div className='col-md-3'>
																<select
																	className='form-control'
																	onChange={this.handleChangeBupot.bind(this)}
																>
																	<option value=''>All</option>
																	<option value='Y'>Yes</option>
																	<option value='N'>No</option>
																</select>
															</div>
															<div className='col-md-2'>Customer</div>
															<div className='col-md-3'>
																<Autocomplete
																	id='customer_auto'
																	onchange={this.onChangeAutocompleteCust.bind(
																		this
																	)}
																	onselect={this.onSelectCustomer.bind(this)}
																/>
															</div>
														</div>
														<div className='row mt-3'>
															<div className='col-md-2'>AWB No Cabang</div>
															<div className='col-md-3'>
																<input
																	type='text'
																	autoComplete='off'
																	className='form-control'
																	id='inputEmail3'
																	name='awbcabang'
																	// placeholder="Description"
																	onChange={this.handleChangeAwbCabang.bind(
																		this
																	)}
																	value={this.state.awbcabang}
																/>
															</div>
															<div className='col-md-2'>AWB No HO</div>
															<div className='col-md-3'>
																<input
																	type='text'
																	autoComplete='off'
																	className='form-control'
																	id='inputEmail3'
																	name='awbho'
																	// placeholder="Description"
																	onChange={this.handleChangeAwbHO.bind(this)}
																	value={this.state.awbho}
																/>
															</div>
														</div>
														<div className='row mt-3'>
															<div className='col-md-3'>
																<button
																	className='btn btn-primary btn-block'
																	onClick={this.handleSearch.bind(this)}
																>
																	<i class='fas fa-search'></i> Search
																</button>
															</div>
															<div className='col-md-3'>
																<button
																	className='btn btn-success btn-block'
																	onClick={() => this.exportToExcel()}
																>
																	<i class='fas fa-file-excel' /> Export To
																	Excel
																</button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div className='clearfix'>&nbsp;</div>
										<div className='row'>
											<div className='col-lg-12'>{this.renderTable()}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<Loader fullPage loading={this.state.loading} />
				</section>
			</div>
		);
	}
}

export default Summary;
